import React from 'react';
import {InlineTextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Form, Button, Icon} from 'semantic-ui-react';

const SearchButton = ({handleSubmit, loading}) => (
  <Button
    onClick={handleSubmit}
    className="search-org-btn"
    loading={loading}
    primary
    icon
    aria-label="Search Button"
  >
    <Icon name="search" fitted />
  </Button>
);

const SearchOrganization = ({
  dunsNumber,
  uei,
  loading,
  handleInputChange,
  handleSubmit,
  displayError,
  errorMessage,
  dunsToUEIToggle,
}) => {
  return (
    <Form id="searchOrganization_Form" onSubmit={handleSubmit}>
      {dunsToUEIToggle ? (
        <InlineTextBoxField
          action={<SearchButton handleSubmit={handleSubmit} loading={loading} />}
          title="Search by UEI or UEI-EFT"
          label="Search by UEI or UEI-EFT"
          placeholder="123456789123-1234"
          id="uei"
          name="uei"
          size="medium"
          value={uei}
          displayError={displayError}
          errorMessages={errorMessage}
          handleChange={handleInputChange}
        />
      ) : (
        <InlineTextBoxField
          action={<SearchButton handleSubmit={handleSubmit} loading={loading} />}
          title="Search by DUNS#"
          label="Search by DUNS#"
          id="dunsNumber"
          name="dunsNumber"
          size="medium"
          value={dunsNumber}
          displayError={displayError}
          errorMessages={errorMessage}
          handleChange={handleInputChange}
        />
      )}
    </Form>
  );
};
export default SearchOrganization;
